import { render, staticRenderFns } from "./daifuhe.vue?vue&type=template&id=28dbac2c&scoped=true&"
import script from "./daifuhe.vue?vue&type=script&lang=js&"
export * from "./daifuhe.vue?vue&type=script&lang=js&"
import style0 from "./daifuhe.vue?vue&type=style&index=0&id=28dbac2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dbac2c",
  null
  
)

export default component.exports